import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useEntityTotals } from '@printdeal/checkout-frontend';
import { Money } from '../../../../Money';
import { SanitizedOrder } from '../../../../../types/order/Order';

interface OrderFileDesignServiceProps {
  order: SanitizedOrder;
}

type MessageIndexes =
  'filedesignCosts'
  | 'filedesignText'
  | 'filechangeCosts'
  | 'filechangeText'
  | 'filecheckCosts'
  | 'filecheckText';

const serviceMessages = defineMessages({
  filedesignCosts: {
    id: 'fileDesignService.costs',
    defaultMessage: 'File design service costs',
  },
  filedesignText: {
    id: 'fileDesignService.costs.text',
    defaultMessage: 'File designs',
  },
  filechangeCosts: {
    id: 'fileChangeService.costs',
    defaultMessage: 'File change service costs',
  },
  filechangeText: {
    id: 'fileChangeService.costs.text',
    defaultMessage: 'File changes',
  },
  filecheckCosts: {
    id: 'fileCheckService.costs',
    defaultMessage: 'File checks service costs',
  },
  filecheckText: {
    id: 'fileCheckService.costs.text',
    defaultMessage: 'File checks',
  },
});

const getMessageIndex = (serviceName: string, suffix: 'Costs' | 'Text'): MessageIndexes => `${serviceName.toLowerCase().split(' ').join('')}${suffix}` as MessageIndexes;

const OrderServicesPriceSummary = ({
  order,
}: OrderFileDesignServiceProps) => {
  // @ts-expect-error type mismatch
  const { entityTotal } = useEntityTotals({ entity: order });
  const intl = useIntl();

  if (!entityTotal?.services || entityTotal.services.quantity === 0) {
    return null;
  }

  return Object.entries(entityTotal.services.services).map(([key, service]) => (
    <div className="pd-flex pd-gap-x-4" key={key}>
      <div className="pd-flex pd-grow pd-flex-col pd-gap-x-4 lg:pd-flex-row">
        <div className="pd-w-full pd-font-bold lg:pd-w-48">
          {intl.formatMessage(serviceMessages[getMessageIndex(service.serviceName!, 'Costs')])}
        </div>
        <div className="pd-grow">
          {service.quantity}
          {' '}
          {intl.formatMessage(serviceMessages[getMessageIndex(service.serviceName!, 'Text')])}
        </div>
      </div>
      <div>
        <Money
          value={service.basePrice?.totalNet.centAmount ?? 0}
          currency={service.basePrice?.totalNet.currencyCode}
        />
      </div>
    </div>
  ));
};

export default OrderServicesPriceSummary;
